import React from "react";
import styled from "styled-components";

export default function TestimonialBox({ text }) {
  const match = text.match(/[\d,+.%]+/);
  const number = match ? match[0] : "•";
  return (
    <Wrapper>
      <strong>{number}</strong>
      <p>{text}</p>
    </Wrapper>
  );
}

const Wrapper = styled.article`
  width: 100%; min-height: 210px; padding: 28px; border: 1px solid #e1e5e3; border-radius: 22px; background: #fff;
  strong { display: block; color: #0a9250; font-size: 2.1rem; line-height: 1; letter-spacing: -.05em; }
  p { margin-top: 20px; color: #555b69; font-size: .82rem; line-height: 1.7; }
`;
